import GiftIcon from '@/shared/assets/icons/gift.svg?react';
import StarIcon from '@/shared/assets/icons/star.svg?react';
import TonIcon from '@/shared/assets/icons/ton.svg?react';
import { CURRENCY_ORDER, type CurrencyCode } from '@/shared/lib/currency';
import type { AssetTab } from '@/shared/ui/AssetTabs';

const CURRENCY_ICONS: Record<CurrencyCode, React.ReactNode> = {
  TON: <TonIcon className="asset-tabs__tab-icon asset-tabs__tab-icon--ton" />,
  STARS: <StarIcon className="asset-tabs__tab-icon asset-tabs__tab-icon--stars" />,
  GIFT: <GiftIcon className="asset-tabs__tab-icon asset-tabs__tab-icon--gift" />,
};

const CURRENCY_LABELS: Record<CurrencyCode, string> = {
  TON: 'TON',
  STARS: 'Stars',
  GIFT: 'Gifts',
};

export const CURRENCY_TABS: AssetTab<CurrencyCode>[] = CURRENCY_ORDER.map((currency) => ({
  id: currency,
  label: CURRENCY_LABELS[currency],
  icon: CURRENCY_ICONS[currency],
}));
